// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"CreateAlertEventDialog_fullWidth__1AR_g","bold":"CreateAlertEventDialog_bold__1FLFC"};